import React, { useEffect } from "react";
import MaterialTable from 'material-table';

// reactstrap components
import {
    Row,
    Col,
    FormGroup,
    Label,
    Input
} from "reactstrap";

// style
import { table_translate, table_style } from "../../constants/MaterialTable.js";

// services
import { showMessage } from "../../services/message.js";
import { api_GET } from "../../services/api_service.js";
import ValidaAcessoFuncionalidadeAcao from "../../services/acesso.js";

// views
import UsuarioForm from "./UsuarioForm.jsx";

//Context
import { useAuth } from "../../context/auth";


export default function UsuarioLista() {
    const { setLoading } = useAuth();
    
    const [permiteEditar, set_permiteEditar] = React.useState(false);
    const [showDetail, set_showDetail] = React.useState(false);
    const [rowEdit, set_rowEdit] = React.useState(null);
    const [list_table, set_list_table] = React.useState([]);
    const [filtroStatus, set_filtroStatus] = React.useState("Ativo");

    const handleAdd = () => {
        set_rowEdit(null);
        set_showDetail(true);
    }

    const handleEdit = (rowData) => {
        set_rowEdit(rowData);
        set_showDetail(true);
    }

    const handleReturn = () => {
        set_rowEdit(null);
        set_showDetail(false);
        loadList(filtroStatus);
    }

    const loadList = (status) => {
        setLoading(true);
        api_GET(`usuario?status=${status}`)
            .then(result => set_list_table(result.data))
            .catch(err => showMessage("Aviso", err.message, 'error', null))
            .finally(() => setLoading(false));
    }

    const handleFiltroStatus = (event) => {
        set_filtroStatus(event.target.value);
        loadList(event.target.value);
    }

    useEffect(() => {
        ValidaAcessoFuncionalidadeAcao("Usuarios.Editar", function (result) { set_permiteEditar(result) });
        loadList(filtroStatus);
    }, []);

    return (
        <>
            {!showDetail &&
                <div className="content">
                    <Row>
                        <Col md="12">
                            <button type="submit" disabled={!permiteEditar} onClick={handleAdd} className="btn btn-secundary"><i className="fa fa-plus"></i>  Novo Usuário</button>
                            <FormGroup style={{ maxWidth: "200px" }}>
                                <Label for="filtroStatus" style={{ color: "white" }}>Status</Label>
                                <Input type="select" id="filtroStatus" name="filtroStatus" value={filtroStatus} onChange={handleFiltroStatus}>
                                    <option value="Ativo">Ativo</option>
                                    <option value="Inativo">Inativo</option>
                                    <option value="Todos">Todos</option>
                                </Input>
                            </FormGroup>
                            <MaterialTable style={{ minHeight: "auto" }}
                                title=""

                                columns={[
                                    { title: 'Login', field: 'login' },
                                    { title: 'Nome', field: 'nome' },
                                    { title: 'Email', field: 'email' },
                                    { title: 'Perfil', field: 'perfil.descricao' },
                                    { title: 'Status', field: 'status' }
                                ]}
                                data={list_table}
                                isLoading={false}
                                options={{
                                    ...table_style,
                                    filtering: false,
                                    exportButton: true
                                }}
                                actions={[
                                    {
                                        icon: 'edit',
                                        tooltip: 'Editar Registro',
                                        onClick: (event, rowData) => handleEdit(rowData)
                                    }
                                ]}
                                localization={table_translate}
                            />
                        </Col>
                    </Row>
                </div>
            }
            {showDetail &&
                <UsuarioForm item={rowEdit} handleReturn={handleReturn}></UsuarioForm>
            }
        </>
    );
}